<template>
  <div class="container">
    <div class="wrap">
      <div class="title">
        <div class="return" @click="goback">
          <i class="el-icon-arrow-left"></i>返回
        </div>
        <div class="titleText">
          <i class="el-icon-location"></i>
          首页-发布公告
        </div>
      </div>
      <div class="content">
        <div class="contentItem">
          <div class="label">公告标题：</div>
          <div class="input">
            <el-input v-model="title" placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div class="contentItem">
          <div class="label">公告内容：</div>
          <div class="input">
            <el-input
              type="textarea"
              :rows="6"
              placeholder="请输入内容"
              v-model="textarea"
            ></el-input>
          </div>
        </div>
        <div class="contentItem">
          <div class="label">图片上传：</div>
          <div class="input">
            <!-- <el-upload
              action="http://192.168.0.118:18091/self/upload"
              list-type="picture-card"
              :before-upload="beforeAvatarUpload"
              :on-change="handleChange"
              :auto-upload="false"
            >
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    v-if="!disabled"
                    class="el-upload-list__item-delete"
                    @click="handleDownload(file)"
                  >
                    <i class="el-icon-download"></i>
                  </span>
                  <span
                    v-if="!disabled"
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>-->

            <el-upload
              action="#"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :auto-upload="false"
              :on-change="handleImageChange"
              :file-list="fileList"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </div>
        <div class="contentItem">
          <div class="label">接受对象：</div>
          <div class="input">
            <el-select
              v-model="department"
              @change="depachange"
              multiple
              placeholder="请选择"
            >
              <el-option
                v-for="item in readdata"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="contentItem">
          <div class="button" @click="addtip">确认发布</div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
// import ListPopup from "@/components/common/popups/ListPopup";
import { mapState } from "vuex";
import { APIMAP } from "@/constants/apiConstants";
import { getServerData } from "@/utils/fetchData";
export default {
  // components: {
  //   ListPopup
  // },
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      title: "",
      textarea: "",
      department: "",
      img: "",
      fileList: [],
      imgurl: [],
      readdata: [],
    };
  },
  props: {},
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
    this.readres();
    console.log(this.userInfo);
  },
  methods: {
    depachange(e) {
      console.log(e);
      this.department = e;
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter((it) => it.myurl !== file.myurl);
      this.imgurl = this.fileList;
      console.log(this.fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    beforeAvatarUpload(file) {
      console.log("before", file);
    },
    async readres() {
      try {
        const res = await getServerData(
          APIMAP.GET_DEPARTMENT,
          {
            pid: this.userInfo.platformid,
            // type: "1"
          },
          "get"
        );
        this.readdata = res;
      } catch (e) {
        console.log(e);
      }
    },
    async handleImageChange(file, filelist) {
      console.log(file, filelist, "sgsegs");
      if (filelist.length === 0) return;
      if (
        ["image/jpeg", "image/jpg", "image/png"].indexOf(file.raw.type) == -1
      ) {
        this.fileList = [];
        this.$message.error("请上传正确的图片格式");
        return false;
      }
      try {
        const res = await getServerData(
          APIMAP.UPLOAD,
          {
            file: file.raw,
            pid: this.userInfo.platformid,
            type: "1",
          },
          "post",
          0,
          true
        );
        const { url } = res;
        // const temp = [
        //   ...this.fileList,
        //   { name: "", url: url, status: "success" },
        // ];
        this.fileList = [...this.fileList, { ...file, myurl: url }];
        console.log(res, url, this.fileList);
        this.imgurl = this.fileList;
      } catch (e) {
        console.log(e);
      }
    },
    // async handleChange(file, filelist) {
    //   console.log(file, filelist);
    //   if (filelist.length === 0) return;
    //   // const formData = new FormData();
    //   // formData.append("file", file.raw);
    //   try {
    //     const res = await getServerData(
    //       APIMAP.UPLOAD,
    //       {
    //         file: file.raw,
    //         pid: this.userInfo.platformid,
    //         type: "1"
    //       },
    //       "post",
    //       0,
    //       true
    //     );
    //     console.log(res);
    //     const { url } = res;
    //     this.imgurl = url;
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },
    handleSuccess(response, file, fileList) {
      console.log(response, file, fileList);
    },
    goback() {
      this.$router.go(-1);
    },
    async addtip() {
      console.log(
        this.imgurl.length,
        this.textarea,
        this.title,
        this.department
      );
      if (
        this.imgurl.length < 1 ||
        !this.textarea ||
        !this.title ||
        this.department.length < 1
      ) {
        this.$message.error("标题,内容,图片与接受对象为必填项");
        return;
      }
      var imgurl = "";
      var receive = "";
      this.imgurl.forEach((item) => {
        imgurl += item.myurl + "|";
      });
      this.department.forEach((item, i) => {
        if (this.department.length - 1 == i) {
          receive += item;
        } else {
          receive += item + ",";
        }
      });
      console.log(receive);
      try {
        var param = {
          title: this.title,
          content: this.textarea,
          imgurl: imgurl,
          username: this.userInfo.realname,
          uid: this.userInfo.gid,
          pid: this.userInfo.platformid,
          status: 1,
          eids: "0",
          receive: receive,
        };
        console.log(param);
        const res = await getServerData(APIMAP.NOTICS, param, "post");
        console.log("添加公告", res);
        this.$message.success("添加成功");
        this.$router.go(-1);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  box-sizing: border-box;
  padding: 24px 26px;
  width: 100%;

  .wrap {
    background: #fff;
    height: 850px;
    font-size: 16px;
    color: #99a9ba;
    padding: 24px 27px;
    box-sizing: border-box;

    .title {
      display: flex;
      border-bottom: 1px solid #e2e5ec;
      padding-bottom: 18px;
      .return {
        cursor: pointer;
      }
      .titleText {
        margin-left: 23px;
      }
    }

    .content {
      margin-top: 30px;
      border-bottom: 1px solid #e2e5ec;
      min-height: 640px;

      .contentItem {
        display: flex;
        margin-bottom: 24px;
        position: relative;
        &:nth-child(2) {
          margin-bottom: 40px;
        }
        .label {
          color: #394259;
          width: 120px;
          line-height: 40px;
          &:before {
            content: "*";
            color: red;
            position: absolute;
            left: -10px;
            font-size: 12px;
          }
        }

        .button {
          width: 150px;
          height: 42px;
          background: #009157;
          border-radius: 5px;
          text-align: center;
          line-height: 42px;
          color: #fff;
          margin-top: 10px;
          cursor: pointer;
          margin-left: 160px;
        }

        .input,
        .el-select {
          width: 385px;
          line-height: 40px;
        }

        .positionText {
          position: absolute;
          font-size: 12px;
          color: #838997;
          bottom: -25px;
          left: 120px;
        }

        .hasIcons {
          img {
            cursor: pointer;
            width: 40px;
            margin: 0 0 0 10px;
          }
        }
      }
    }
  }
}
</style>